import { Component } from '@angular/core';

@Component({
    selector: 'app-bad-link',
    templateUrl: './bad-link.component.html',
    styleUrls: ['./bad-link.component.scss'],
    host: { 'style': 'width: 100%', 'display': 'block' }
})
export class BadLinkComponent { }
